import {AxiosResponse} from 'axios';
//api
import {orgAPI, userAPI} from '@/core/api';
//types
import {IUserBid, IBuyItem, BuyItemRes} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class UserBidService {
	static createBid = async (reqBody: IUserBid): Promise<AxiosResponse> => userAPI.post(API_URL.CREATE_BID, reqBody);

	static buyItem = async (reqBody: IBuyItem): Promise<AxiosResponse<BuyItemRes>> =>
		userAPI.post(API_URL.BUY_ITEM, reqBody);

	static addWinner = async (reqBody: IUserBid): Promise<AxiosResponse> => orgAPI.post(API_URL.ADD_WINNER, reqBody);

	static deleteWinner = async (itemId: number): Promise<AxiosResponse> =>
		orgAPI.delete(`${API_URL.ADD_WINNER}/${itemId}`);
}

export {UserBidService};
